export default __webpack_public_path__ + "static/media/print.35ad0293.svg";